import React from 'react';
import { Image, Text, View } from 'react-native-web';
import { Android } from '../../../../utils/DictionaryManagementUtils';
import { img_and_select_kbd, img_scr_onboarding_03_a_and } from '../../../../utils/ImagesManagementUtils';
import { getMediumFont, xlateText } from '../../../../utils/Utils';

const SelectKeyboardComponent = ({
  globJSON,
  simPlatform,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { instructions } = globJSON.configurations.onboarding;
  const myStyles = {
    phoneImage: {
      width: 240,
      height: simPlatform === Android ? 427 : 520,
      position: 'absolute',
      backgroundColor: simPlatform === Android
        ? '#f0f5f9'
        : colors.app_background_color,
    },
    radioButtonImageStyle: {
      width: 180,
      height: 175,
      marginTop: 30,
      alignSelf: 'center',
    },
    titleBarContainerStyle: {
      width: 104,
      height: 20,
      marginLeft: 67,
      marginTop: 60,
      position: 'absolute',
      justifyContent: 'center',
    },
    titleBarTextStyle: {
      width: 104,
      fontFamily: `${getMediumFont(globJSON, simPlatform, true)}`,
      fontSize: 9.3,
      color: '#909090',
    },
    selectKeyboardContainer: {
      width: 104,
      height: 20,
      marginLeft: 55,
      marginTop: 100,
      position: 'absolute',
      justifyContent: 'center',
    },
    selectKeyboardText: {
      width: 104,
      fontFamily: `${getMediumFont(globJSON, simPlatform, true)}`,
      fontSize: 9.3,
      color: '#001a2f',
      lineSpacingExtra: 6,
    },
    bankKeyboardContainer: {
      width: 104,
      height: 20,
      marginLeft: 67,
      marginTop: 118,
      position: 'absolute',
      justifyContent: 'center',
    },
    bankKeyboardText: {
      width: 104,
      fontFamily: `${getMediumFont(globJSON, simPlatform, true)}`,
      fontSize: 9.3,
      color: '#010101',
    },
    otherKeyboardContainer: {
      width: 104,
      height: 20,
      marginLeft: 67,
      marginTop: 138,
      position: 'absolute',
      justifyContent: 'center',
    },
    otherKeyboardText: {
      width: 104,
      fontFamily: `${getMediumFont(globJSON, simPlatform, true)}`,
      fontSize: 9.3,
      color: '#001a2f',
      lineSpacingExtra: 6,
    },
  };

  return (

    <View>
      <Image
        fadeDuration={0}
        style={myStyles.phoneImage}
        source={img_scr_onboarding_03_a_and}
      />
      <View>
        <Image
          fadeDuration={0}
          style={myStyles.radioButtonImageStyle}
          source={img_and_select_kbd}
        />

        <View style={myStyles.titleBarContainerStyle}>
          <Text style={myStyles.titleBarTextStyle}>
            {xlateText(instructions.onboarding_titleBar, globJSON)}
          </Text>
        </View>

        <View style={myStyles.selectKeyboardContainer}>
          <Text style={myStyles.selectKeyboardText}>
            {xlateText(instructions.select_keyboard, globJSON)}
          </Text>
        </View>

        <View style={myStyles.bankKeyboardContainer}>
          <Text style={myStyles.bankKeyboardText}>
            {xlateText(instructions.bank_keyboard, globJSON)}
          </Text>
        </View>

        <View style={myStyles.otherKeyboardContainer}>
          <Text style={myStyles.otherKeyboardText}>
            {xlateText(instructions.other_keyboards, globJSON)}
          </Text>
        </View>
      </View>
    </View>
  );
};

export default SelectKeyboardComponent;
